/** append modal in footer for better UX*/
let body = document.body;
if (!customElements.get('mirr-quick-size-recommended-modal')) {
  class MirrorQuickSizeModalDialog extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
  }

  customElements.define('mirr-quick-size-recommended-modal', MirrorQuickSizeModalDialog);
}



//manage model image on click on gender /


const updateBackgroundImagesQuickSizeAA = (blockId, gender) => {
  const sections = ['chest', 'stomach', 'hip'];
  sections.forEach(section => {
    ['flat', 'mid', 'high'].forEach(type => {
      const element = document.querySelector(`[data-ms-aa-${section}-${type}--${blockId}]`);
      if (element) {
        element.style.backgroundImage = `url(${window.aaImageScrQuickSize[section][gender][type]})`;
      }
    });
  }); 
};

document.querySelectorAll('[data-gender-aa-triggered-cls-quick-size]').forEach(allGenderChoiseEle => {
  allGenderChoiseEle.addEventListener('click', () => {
    const blockId = allGenderChoiseEle.getAttribute('data-block-id');
    const choiseValue = allGenderChoiseEle.getAttribute('value');
    const gender = choiseValue === 'male' ? 'male' : 'female';

    updateBackgroundImagesQuickSizeAA(blockId, gender);
  });
});


setTimeout(function () {


  document.querySelectorAll(".ms-mirr-quick-size-block-modal").forEach(function (quickSizeBlock) {
    let blockId = quickSizeBlock.getAttribute("block-id");

    const autoSelectGender = () => {
      let selectedGender = window.aa_product_gender_mirr_quick_size;

      if (!selectedGender) return;
      if (selectedGender === "unisex") {
        clearInterval(genderInterval);
        return;
      }
      let radio = quickSizeBlock.querySelector(`input[name='gender-${blockId}'][value='${selectedGender}']`);
      if (radio) { radio.checked = true;}
      radio.dispatchEvent(new Event("click", { bubbles: true }));
      quickSizeBlock.querySelectorAll(`input[name='gender-${blockId}']`).forEach(r => r.disabled = true);
      const genderGroup = document.getElementById(`genderGroup-${blockId}`);
      const genderLabel = document.querySelector(`label[for='genderGroup--aa-${blockId}']`);

      if (genderGroup) genderGroup.style.display = "none";
      if (genderLabel) genderLabel.style.display = "none";
      clearInterval(genderInterval);
    };
    const genderInterval = setInterval(autoSelectGender, 200);
    autoSelectGender();


    const steps = [
      `step1-${blockId}`,
      `step2-${blockId}`,
      `step3-${blockId}`,
      `step4-${blockId}`,
      `step5-${blockId}`,
    ];

    let current = 0;

    const nextBtn = quickSizeBlock.querySelector(`#nextBtn-l1--${blockId}`);
    const backBtn = quickSizeBlock.querySelector(`#backBtn-l1--${blockId}`);
    const submitBtn = quickSizeBlock.querySelector(`#submitBtn-l1--${blockId}`);
    let advisorModal = document.querySelector(`.nr-cm-modal--js--${blockId}`);
    let cmmodalfooter = document.querySelector(`.cm-modal-footer-l1--js--${blockId}`);
    let ollst = document.querySelector(`.cm-modal-footer-l1--js--${blockId} ul.ollst`);


    // FIX → use const function expression

    document.querySelector(`#mirr-btn-quick-${blockId}`)?.addEventListener("click", () => {
      body.classList.add('nr-cm-modal-open');
      showStep(0);
      advisorModal.style.visibility = 'visible';
      advisorModal.style.opacity = '1';
    });
    document.querySelector(`#cm-close--js--${blockId}`)?.addEventListener("click", () => {
      body.classList.remove('nr-cm-modal-open');
      advisorModal.style.visibility = 'hidden';
      advisorModal.style.opacity = '0';
      showStep(0);
      ollst.classList.remove('hidden');
      cmmodalfooter.style.display = 'flex';
      current = 0;
    })

  const  highlightSteps = (stepNumber)=> {
    const allLi = document.querySelectorAll(`.cm-modal-footer-l1--js--${blockId} .ollst li`);
    allLi.forEach((li, i) => {
      li.classList.toggle('active', i === stepNumber);
    });
  }


    const showStep = (index) => {
      document.getElementById(steps[current]).classList.add('hidden');
      current = index;
      document.getElementById(steps[current]).classList.remove('hidden');

       highlightSteps(current);

      nextBtn.classList.toggle('hidden', current === steps.length - 1);
      submitBtn.classList.toggle('hidden', current !== steps.length - 1);



      backBtn.classList.remove('hidden');
      backBtn.disabled = current === 0;
      backBtn.classList.toggle('disabled', current === 0);

      if (window.innerWidth < 991) {
        advisorModal.style.maxWidth = index === 4 ? '98%' : '';
      } else {
        advisorModal.style.maxWidth = index === 4 ? '65%' : '';
      }

      if (current === 3) {
        nextBtn.classList.add('hidden');
        submitBtn.classList.remove('hidden');
      }

      if (current === 4) {
        nextBtn.classList.add('hidden');
        backBtn.classList.add('hidden');
        submitBtn.classList.add('hidden');
        ollst.classList.add('hidden');
        cmmodalfooter.style.display = 'none';
      }
    };

    nextBtn?.addEventListener("click", () => {
      if (current === 0 && !validateFromStep_1L1(blockId)) return;
      if (current < steps.length - 1) showStep(current + 1);
    });

    backBtn?.addEventListener("click", () => {
      if (current > 0) showStep(current - 1);
    });

    submitBtn?.addEventListener("click", () => {
      submitQuickSize(submitBtn, blockId);
    });

    showStep(0);



    const heightInput = document.getElementById(`height-${blockId}`);
    const heightFtIn = document.querySelector(`.cmin-l1-${blockId}`);
    const heightUnit = document.getElementById(`heightUnit-${blockId}`);
    heightUnit.addEventListener('change', () => {
      if (heightUnit.value === 'cm') {
        heightInput.classList.remove('unhidden');
        heightFtIn.classList.add('unhidden');
        heightft.value = '';
        heightin.value = '';
      } else {
        heightInput.classList.add('unhidden');
        heightFtIn.classList.remove('unhidden');
        heightInput.value = '';
      }
    });
    const weightKg = document.getElementById(`weight-${blockId}`);
    const weightLbs = document.getElementById(`weightlbs-${blockId}`);
    const weightUnit = document.getElementById(`weightUnit-${blockId}`);
    if (weightUnit.value === 'kg') {
      weightKg.classList.remove('hidden');
      weightLbs.classList.add('hidden');
    } else {
      weightKg.classList.add('hidden');
      weightLbs.classList.remove('hidden');
    }
    weightUnit.addEventListener('change', () => {
      if (weightUnit.value === 'kg') {
        weightKg.classList.remove('hidden');
        weightLbs.classList.add('hidden');
        weightLbs.value = '';
      } else {
        weightKg.classList.add('hidden');
        weightLbs.classList.remove('hidden');
        weightKg.value = '';
      }
    });
    heightInput.addEventListener('input', () => {
      if (heightInput.value.length > 3) {
        heightInput.value = heightInput.value.slice(0, 3);
      }
    });

    const heightft = document.getElementById(`heightft-${blockId}`);
    heightft.addEventListener('input', () => {
      if (heightft.value.length > 1) {
        heightft.value = heightft.value.slice(0, 1);
      }
    });

    const heightin = document.getElementById(`heightin-${blockId}`);
    heightin.addEventListener('input', () => {
      if (heightin.value.length > 2) {
        heightin.value = heightin.value.slice(0, 2);
      }
    });

    const weight = document.getElementById(`weight-${blockId}`);
    weight.addEventListener('input', () => {
      if (weight.value.length > 3) {
        weight.value = weight.value.slice(0, 3);
      }
    });

    const weightlbs = document.getElementById(`weightlbs-${blockId}`);
    weightlbs.addEventListener('input', () => {
      if (weightlbs.value.length > 3) {
        weightlbs.value = weightlbs.value.slice(0, 3);
      }
    });
    if (window.product_gender_mirr_quick_size) {
      // Select radio button
      let radio = document.querySelector(
        `input[name='gender-${blockId}'][value='${window.product_gender_mirr_quick_size}']`
      );
      if (radio) {
        radio.checked = true;
      }
      // Disable both radios
      document
        .querySelectorAll(`input[name='gender-${blockId}']`)
        .forEach(r => r.disabled = true);
    }



    function submitQuickSize(_this, blockId) {
      var age = Number(document.getElementById(`age-${blockId}`)?.value);
      var gender = document.querySelector(`input[name='gender-${blockId}']:checked`)?.value;
      var height = Number(document.getElementById(`height-${blockId}`)?.value);
      var heightUnit = document.getElementById(`heightUnit-${blockId}`)?.value;
      var weight = Number(document.getElementById(`weight-${blockId}`)?.value);
      var weightUnit = document.getElementById(`weightUnit-${blockId}`)?.value;
      var stomachShape = document.querySelector(`input[name="stomachShape-${blockId}"]:checked`)?.value;
      var chestShape = document.querySelector(`input[name="chestShape-${blockId}"]:checked`)?.value;
      var hipShape = document.querySelector(`input[name="hipShape-${blockId}"]:checked`)?.value;

      var totalHeightMillimeters = Number(height) * 10 //convert cm into mm 1cm = 10 mm, default cm selected
      if (heightUnit == "in") {
        var heightft = Number(document.getElementById(`heightft-${blockId}`)?.value) ?? 0;
        var heightin = Number(document.getElementById(`heightin-${blockId}`)?.value) ?? 0;
        var totalHeightInches = heightft * 12 + heightin;
        // var totalHeightCm = totalHeightInches * 2.54;
        totalHeightMillimeters = totalHeightInches * 25.4; // Convert total height to millimeters
      }
      if (weightUnit == "lbs") {
        var weightlbs = Number(document.getElementById(`weightlbs-${blockId}`)?.value) ?? 0;
        weight = weightlbs / 2.20; // convert lbs to kg
      }
      var formDataObj = {
        merchantId: 'vaughan@g2performance.com',
        apiKey: 'KSj9Fi1QtvZ2MOpSBPfEfrlSTyEFdi8DdDK8AspqflnflgsS6iLTjoDzaNlSL8yG',
        sku: window.sku,
        height: totalHeightMillimeters.toFixed(2), // Send total height in millimeters to the server
        weight: weight.toFixed(2),
        age: age,
        genderType: 'adult',
        gender: gender || "",
        stomachShape: stomachShape,
        chestShape: chestShape,
        hipShape: hipShape,
      };
      var formDataForStore = {
        height: totalHeightMillimeters.toFixed(2), // Send total height in millimeters to the server
        weight: weight.toFixed(2),
        age: age,
        genderType: 'adult',
        gender: 'male',
        stomachShape: stomachShape,
        chestShape: chestShape,
        hipShape: hipShape,
      };
      _this.innerHTML = "Getting size...";
      fetch('https://api.services.mirrorsize.com/api/sdk/quicksize/sku/bmirecommendation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataObj),
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) {
            throw { status: response.status, data };
          }
          return data;
        })
        .then((data) => {
          _this.innerHTML = "SUBMIT";
          // localStorage.setItem(`ms_quick_size_layout_2_form_data--${blockId}`, JSON.stringify(formDataForStore)); 
          if (data.code === 1) {
            if (data.isNewRecom === false) {
              var sizeResult = data.data[0].size;
              var apparelName = data.data[0].apparelId;
              var resHml = `
               <div id="sizing-ai">
                  <div class="row" style="display: flex;justify-content: center;">
                    <div class="col-md-12">
                        <h4 class="text-center pb-5 pt-4 fs-1">Thank you for using our size advisor!</h4>
                    </div>
                  </div>

                  <div class="row cust-sizing-ai" style=" display: flex; justify-content: center;">

                   <div class="cmfinal-rl" style="margin-top:0px">
                       <p style="font-weight:100"> Based on your input, we recommend a size of <span style="font-weight:800"> ${sizeResult}</span> for the <span style="font-weight:800">${apparelName} </span></p>
                      <div
                          class="text-center pb-5 pt-4 fs-1"
                          style="font-weight: 300; margin-top: 20px;font-size: 20px;"
                        >
                          <button type="button" class="btn btn--primary btn--solid close-ms-btn-form close-ms-btn-form--${blockId}" id="submitFItForm" tabindex="0">
                          <span>Done</span>
                          </button>
                      </div>
                    </div>
                  </div>
               </div>
              `
              document.getElementById(`show_data-${blockId}`).innerHTML = resHml;
              showStep(4);
            } else if (data.isNewRecom === true) {
              var resHtml = `
                    <div id="sizing-ai">
                        <div class="row">
                        <div class="col-md-12">
                            <h4 class="text-center pb-5 pt-4 fs-1">Thank you for using our size advisor!</h4>
                        </div>
                        </div>

                        <div class="row cust-sizing-ai">
                        <!-- TIGHT FIT -->
                        <div class="col-md-4">
                            <p class="text-center">Tight Fit</p>
                            <div class="box1 mx-4 px-4" style="margin-top: 50px;">
                            <label><span id="size_name1">${data.data[0]?.fitScore?.sizeBefore}</span></label>
                            <div class="position-relative">
                                <span class="process_bar"></span>
                                <span class="process_btn" id="size_score10" style="left: calc(${(data.data[0]?.fitScore?.sizeBefore_score > 10 ? data.data[0]?.fitScore?.sizeBefore_score : 10)}% - 10%);"></span>
                            </div>
                            <div>
                                <div class="d-flex justify-content-between">
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                </div>
                            </div>
                            </div>
                            <div class="d-flex d_sizing_name justify-content-between">
                            <span>Slightly Tight</span>
                            <span>Tight</span>
                            <span>Very Tight</span>
                            </div>
                        </div>

                        <!-- BEST FIT -->
                        <div class="col-md-4">
                            <p class="text-center">Your Best Fit</p>
                            <div class="g_circle" style="width:150px; margin:0 auto; position: relative;">
                            <svg width="100%" height="100%" viewBox="0 0 42 42" class="donut">
                              <circle class="donut-hole" cx="21" cy="21" r="15.91549430918954" fill="#fff"></circle>
                              <circle class="donut-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#ebeef0" stroke-width="3"></circle>
                              <circle class="donut-segment" id="gourav_svg" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#4f4e4e" stroke-width="3" stroke-dashoffset="25" stroke-dasharray="${data.data[0]?.fitScore?.recomSize_score} ${100 - data.data[0]?.fitScore?.recomSize_score}"></circle>
                            </svg>
                            <h4 style="color:#000; position: absolute; top: 58px; width: 100%; text-align: center; font-size: 18px; font-weight: 800; margin-bottom: 0px;">
                                <span id="size_name3">${data.data[0]?.fitScore?.recomSize}</span>
                            </h4>
                            <span class="size_name3_sss-p"> Fit Score: <small id="size_name3_sss">${Math.ceil(data.data[0]?.fitScore?.recomSize_score)}% </small> </span>
                            </div>
                        </div>

                        <!-- LOOSE FIT -->
                        <div class="col-md-4">
                            <p class="text-center">Loose Fit</p>
                            <div class="box1 mx-4 px-4" style="margin-top: 50px;">
                            <label><span id="size_name2">${data.data[0]?.fitScore?.sizeAfter}</span></label>
                            <div class="position-relative">
                                <span class="process_bar green"></span>
                                <span class="process_btn1 green" id="size_score30" style="left: calc(${(data.data[0]?.fitScore?.sizeAfter_score > 10 ? data.data[0]?.fitScore?.sizeAfter_score : 10)}% - 10%);"></span>
                            </div>
                            <div>
                                <div class="d-flex justify-content-between">
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                </div>
                            </div>
                            </div>
                            <div class="d-flex d_sizing_name justify-content-between">
                            <span>Slightly Loose</span>
                            <span>Loose</span>
                            <span>Very Loose</span>
                            </div>
                        </div>
                        </div>

                        <div class="cmfinal-rl">
                       <p> Your recommended "Length" size is : <span id="apparelName" style="font-weight: 700">${data.data[0]?.fitScore?.recomSize}</span></p>
                        <div
                            class="text-center pb-5 pt-4 fs-1"
                            style="font-weight: 300; margin-top: 20px;font-size: 20px;"
                          >
                            <button type="button" class="addProduct button w-full close-ms-btn-form close-ms-btn-form--${blockId}" id="submitFItForm" tabindex="0">
                            <span>Done</span>
                            </button>
                          </div>
                        </div>
                    </div>
                     
                    `;

              document.getElementById(`show_data-${blockId}`).innerHTML = resHtml;
              showStep(4);

            }
          } else {
            console.log("Error in ms get size.",);
            document.getElementById(`response-error-${blockId}`).innerHTML = data.message
            setTimeout(function () {
              document.getElementById(`response-error-${blockId}`).innerHTML = "";
            }, 5000);
          }
        })
        .catch((error) => {
          _this.innerHTML = "SUBMIT";
          console.error('Error :', error);
          if (error?.data?.message) {
            document.getElementById(`response-error-${blockId}`).innerHTML = error?.data?.message ?? '';
            setTimeout(function () {
              document.getElementById(`response-error-${blockId}`).innerHTML = "";
            }, 5000);
          }

        })
    };

    const weightUnitElet = document.getElementById(`weightUnit-${blockId}`);
    weightUnitElet.value = "lbs";
    weightUnitElet.dispatchEvent(new Event('change', { bubbles: true }));

    const heightUnitElet = document.getElementById(`heightUnit-${blockId}`);
    heightUnitElet.value = "in";
    heightUnitElet.dispatchEvent(new Event('change', { bubbles: true }));


    document.addEventListener('click', function (e) {
      const btn = e.target.closest(`.close-ms-btn-form--${blockId}`);
      if (btn) {
        e.preventDefault();
        const target = document.querySelector(`#cm-close--js--${blockId}`);
        if (target) target.click();
      }
    }, true);
  });


}, 2000);


function validateFromStep_1L1(blockId) {

  let isValid = true;

  // Clear all previous errors
  document.querySelectorAll(`.form-error-${blockId}`).forEach(err => err.innerHTML = "");

  // Age validation
  const age = document.getElementById(`age-${blockId}`).value;
  if (!age) {
    document.querySelector(`.age_error-${blockId}`).innerHTML = "Please select your age.";
    isValid = false;
  }

  // Height validation
  const heightUnit = document.getElementById(`heightUnit-${blockId}`).value;

  if (heightUnit === "cm") {
    const heightCm = parseInt(document.getElementById(`height-${blockId}`).value, 10);
    if (!heightCm || isNaN(heightCm)) {
      document.querySelector(`.height_unit_error-${blockId}`).innerHTML = "Please enter your height.";
      isValid = false;
    } else if (heightCm < 140 || heightCm > 220) {
      document.querySelector(`.height_unit_error-${blockId}`).innerHTML = "Height should be between 140 cm and 220 cm.";
      isValid = false;
    }
  } else {
    const heightFt = parseInt(document.getElementById(`heightft-${blockId}`).value, 10) || 0;
    const heightIn = parseInt(document.getElementById(`heightin-${blockId}`).value, 10) || 0;
    const inches = (heightFt * 12) + heightIn;
    const heightmm = ((inches * 2.54) * 10).toFixed(2);
    if (heightFt === 0 && heightIn === 0) {
      document.querySelector(`.height_unit_error-${blockId}`).innerHTML = "Please enter your height.";
      isValid = false;
    } else if (heightmm < 1400 || heightmm > 2200) {
      document.querySelector(`.height_unit_error-${blockId}`).innerHTML = "Height should be between 4 feet 7 inches to 7 feet to 2 inches.";
      isValid = false;
    }
  }

  // Weight validation
  const weightUnit = document.getElementById(`weightUnit-${blockId}`).value;

  if (weightUnit === "kg") {
    const weightKg = parseInt(document.getElementById(`weight-${blockId}`).value, 10);
    if (!weightKg || isNaN(weightKg)) {
      document.querySelector(`.weight_unit_error-${blockId}`).innerHTML = "Please enter weight in kg.";
      isValid = false;
    } else if (weightKg < 30 || weightKg > 150) {
      document.querySelector(`.weight_unit_error-${blockId}`).innerHTML = "Weight should be between 30–150 kg.";
      isValid = false;
    }
  } else {
    const weightLbs = parseInt(document.getElementById(`weightlbs-${blockId}`).value, 10);
    if (!weightLbs || isNaN(weightLbs)) {
      document.querySelector(`.weight_unit_error-${blockId}`).innerHTML = "Please enter weight in lbs.";
      isValid = false;
    } else if (weightLbs < 66 || weightLbs > 333) {
      document.querySelector(`.weight_unit_error-${blockId}`).innerHTML = "Weight should be 66–333 lbs.";
      isValid = false;
    }
  }

  // Gender validation (if required)
  const genderChecked = document.querySelector(`input[name^='gender-${blockId}']:checked`);
  if (!genderChecked) {
    document.querySelector(`.gender_error-${blockId}`).innerHTML = "Please select gender.";
    isValid = false;
  }

  // If any error — stop
  if (!isValid) return false;

  // Success
  //showStep(2);
  return true;
}



